export const LOADER = 'loader';
export const LOADER_NO_NAME_BRANDS = 'loader-no-name-brands';
export const LOADER_PM = 'loader-pm';
export const LOADER_PM_BY = 'loader-pm-by';

export const SKELETON = 'skeleton';
export const BUTTON_TO_TOP = 'button-to-top';
export const FAVOURITE_ACTIVE = 'favourites-active';
export const FAVOURITE_NOT_ACTIVE = 'favourites-not-active';

export const MODAL_OVERLAY = 'modal-overlay';
export const MODAL_CONTENT = 'modal-content';

export const NAVIGATION_MAIN = 'navigation-main';
export const NAVIGATION_MAIN_LINK = 'navigation-main-link';
export const NAVIGATION_MAIN_LINK_ICON = 'navigation-main-link-icon';
export const NAVIGATION_MAIN_LINK_NAME = 'navigation-main-link-name';
export const NAVIGATION_MAIN_LINK_ARROW = 'navigation-main-link-arrow';

export const NAVIGATION_CATEGORIES = 'navigation-categories';
export const NAVIGATION_CATEGORIES_LINK = 'navigation-categories-link';
export const NAVIGATION_CATEGORIES_LINK_ICON =
  'navigation-categories-link-icon';
export const NAVIGATION_CATEGORIES_LINK_ARROW =
  'navigation-categories-link-arrow';
export const NAVIGATION_CATEGORY_LINK = 'navigation-category-link';
export const NAVIGATION_LINK = 'navigation-link';
export const NAVIGATION_LINK_ICON = 'navigation-link-icon';
export const NAVIGATION_LINK_ARROW = 'navigation-link-arrow';
export const NAVIGATION_LINK_GAME_COUNT = 'navigation-link-game-count';
export const NAVIGATION_SECTION_LINK = 'navigation-section-link';
export const NAVIGATION_CATEGORIES_TOGGLE = 'navigation-categories-toggle';

export const NAVIGATION_THEMES = 'navigation-themes';
export const NAVIGATION_THEMES_LINK = 'navigation-themes-link';
export const NAVIGATION_THEMES_LINK_ICON = 'navigation-themes-link-icon';
export const NAVIGATION_THEMES_LINK_ARROW = 'navigation-themes-link-arrow';
export const NAVIGATION_THEME_LINK = 'navigation-theme-link';
export const NAVIGATION_THEMES_TOGGLE = 'navigation-themes-toggle';

export const NAVIGATION_PROVIDERS = 'navigation-providers';
export const NAVIGATION_PROVIDERS_LINK = 'navigation-providers-link';
export const NAVIGATION_PROVIDERS_LINK_ICON = 'navigation-providers-link-icon';
export const NAVIGATION_PROVIDERS_LINK_ARROW =
  'navigation-providers-link-arrow';
export const NAVIGATION_PROVIDER_LINK = 'navigation-provider-link';
export const NAVIGATION_PROVIDER_LINK_LOGO = 'navigation-provider-link-logo';
export const NAVIGATION_PROVIDER_LINK_TITLE = 'navigation-provider-link-title';
export const NAVIGATION_PROVIDER_LINK_GAME_COUNT =
  'navigation-provider-link-game-count';

export const HEADER_MOBILE = 'header-mobile';
export const HEADER_DESKTOP = 'header-desktop';
export const HEADER_BACK_BUTTON = 'header-back-button';
export const HEADER_BONUSES_LINK = 'header-bonuses-link';
export const HEADER_MENU_BUTTON = 'header-menu-button';
export const HEADER_SEARCH_BUTTON = 'header-search-button';
export const HEADER_FAVOURITES_BUTTON = 'header-favourites-button';
export const HEADER_TITLE = 'header-title';

export const TOP_SLIDER = 'top-slider';
export const TOP_SLIDER_ITEM = 'top-slider-item';
export const TOP_SLIDER_IMAGE = 'top-slider-image';
export const TOP_SLIDER_TITLE = 'top-slider-title';
export const TOP_SLIDER_DESCRIPTION = 'top-slider-description';
export const TOP_SLIDER_BUTTON = 'top-slider-button';

export const HEADING = 'heading';
export const HEADING_TITLE = 'heading-title';
export const HEADING_LINK = 'heading-link';

export const SEARCH_FORM = 'search-form';
export const SEARCH_FORM_INPUT = 'search-form-input';
export const SEARCH_FORM_ICON = 'search-form-icon';
export const SEARCH_FORM_BACK = 'search-form-back';
export const SEARCH_FORM_CLEAR = 'search-form-clear';

export const QUICK_SEARCH = 'quick-search';
export const QUICK_SEARCH_TITLE = 'quick-search-title';
export const QUICK_SEARCH_GAME_LIST = 'quick-search-games-list';
export const QUICK_SEARCH_RESULT_LINK = 'quick-search-result-link';
export const QUICK_SEARCH_GAME_LINK = 'quick-search-game-link';
export const QUICK_SEARCH_GAME_IMAGE = 'quick-search-game-image';

export const GAME_CARD = 'game-card';
export const GAME_IMAGE = 'game-image';
export const GAME_FAVOURITE_BUTTON = 'game-favourite-button';
export const GAME_LINK = 'game-link';
export const GAME_PLAY_BUTTON = 'game-play-button';
export const CARDS_LINE = 'cards-line';

export const SECTION_CARD = 'section-card';
export const SECTION_TITLE = 'section-title';
export const SECTION_SUBTITLE = 'section-subtitle';
export const SECTION_ICON = 'section-icon';
export const SECTION_BACKGROUND = 'section-background';

export const SECTION_HEADER = 'section-header';
export const SECTION_HEADER_TITLE = 'section-header-title';
export const SECTION_HEADER_SUBTITLE = 'section-header-subtitle';
export const SECTION_HEADER_ICON = 'section-header-icon';
export const SECTION_HEADER_BACKGROUND = 'section-header-background';
export const SECTION_HEADER_LOGO = 'section-header-logo';

export const CATEGORY_GAMES_LIST = 'category-games-list';
export const THEME_GAMES_LIST = 'theme-games-list';
export const PROVIDER_GAMES_LIST = 'provider-games-list';
export const RECENT_GAMES_LIST = 'recent-games-list';
export const RECENT_SEARCHED_GAMES_LIST = 'recent-searched-games-list';

export const THEMES_GRID = 'themes-grid';
export const CATEGORIES_GRID = 'categories-grid';
export const PROVIDERS_GRID = 'providers-grid';
export const THEME_GAMES_GRID = 'theme-games-grid';
export const CATEGORY_GAMES_GRID = 'category-games-grid';
export const PROVIDER_GAMES_GRID = 'provider-games-grid';
export const BONUS_GAMES_GRID = 'bonus-games-grid';
export const FAVOURITES_GAMES_GRID = 'favourites-games-grid';
export const RECENT_GAMES_GRID = 'recent-games-grid';
export const SEARCH_RESULT_GAMES_GRID = 'search-result-games-grid';

export const SLIDER_ARROW_PREVIOUS = 'slider-arrow-previous';
export const SLIDER_ARROW_NEXT = 'slider-arrow-next';

export const THEMES_LIST = 'themes-list';
export const CATEGORIES_LIST = 'categories-list';
export const CROSSSALES_LIST = 'crosssales-list';
export const PROVIDERS_LIST = 'providers-list';

export const PROVIDERS_ITEM_LINK = 'providers-item-link';
export const PROVIDERS_ITEM_LINK_ICON = 'providers-item-link-icon';
export const PROVIDERS_SORT_ORDER = 'providers-sort-order';

export const PAGINATION = 'pagination';
export const PAGINATION_PREV_BUTTON = 'pagination-prev-button';
export const PAGINATION_NEXT_BUTTON = 'pagination-next-button';

export const ACTIVE_BONUS_MESSAGE = 'active-bonus-message';
export const ACTIVE_BONUS_IS_AVAILABLE = 'active-bonus-is-available';
export const ACTIVE_BONUS_IS_NOT_AVAILABLE = 'active-bonus-is-not-available';
export const ACTIVE_BONUS_MESSAGE_CLOSE = 'active-bonus-message-close';

export const GAME_HEADER_MOBILE = 'game-header-mobile';
export const GAME_HEADER_DESKTOP = 'game-header-desktop';
export const GAME_CLOSE_BUTTON = 'game-close-button';
export const GAME_FULLSCREEN_BUTTON = 'game-fullscreen-button';
export const GAME_PLAY_REAL = 'game-play-real';
export const GAME_PLAY_DEMO = 'game-play-demo';
export const GAME_PROVIDER = 'game-provider';
export const GAME_TITLE = 'game-title';
export const GAME_IFRAME = 'game-iframe';

export const GAME_PREVIEW_MOBILE = 'game-preview-mobile';
export const GAME_PREVIEW_DESKTOP = 'game-preview-desktop';

export const NEW_BONUSES_PICTOGRAM = 'new-bonuses-pictogram';
export const WELCOME_BONUS_OVERLAY = 'welcome-bonus-overlay';
export const WELCOME_BONUS_DIALOG = 'welcome-bonus-dialog';

export const ACTIVE_BONUSES = 'active-bonuses';
export const ACTIVE_BONUSES_LIST = 'active-bonuses-list';
export const AVAILABLE_BONUSES = 'available-bonuses';
export const AVAILABLE_BONUSES_LIST = 'available-bonuses-list';
export const BONUSES_HISTORY_LINK = 'bonuses-history-link';
export const BONUSES_HISTORY = 'bonuses-history';
export const BONUSES_HISTORY_LIST = 'bonuses-history-list';

export const BONUS_TABS = 'bonus-tabs';
export const BONUS_TAB_CURRENT = 'bonus-tab-current';
export const BONUS_TAB_HISTORY = 'bonus-tab-history';

export const BONUS_CARD = 'bonus-card';
export const BONUS_LINK = 'bonus-link';
export const BONUS_TITLE = 'bonus-title';
export const BONUS_AMOUNT = 'bonus-amount';
export const BONUS_IMAGE = 'bonus-image';
export const BONUS_STATUS = 'bonus-status';
export const BONUS_PROGRESS_BAR = 'bonus-progress-bar';
export const BONUS_PROGRESS_STATUS = 'bonus-progress-status';
export const BONUS_PROGRESS_TIMER = 'bonus-progress-timer';
export const BONUS_EXPIRATION_DATE = 'bonus-expiration-date';
export const BONUS_WAGERING_AMOUNT = 'bonus-wagering-amount';
export const BONUS_STATUS_DESCRIPTION = 'bonus-status-description';
export const BONUS_NOT_AVAILABLE = 'bonus-not-available';

export const BONUS_BUTTON_ACTIVATE = 'bonus-button-activate';
export const BONUS_BUTTON_DEPOSIT = 'bonus-button-deposit';
export const BONUS_BUTTON_SUPPORT = 'bonus-button-support';
export const BONUS_BUTTON_UNJOIN = 'bonus-button-unjoin';
export const BONUS_BUTTON_REJECT = 'bonus-button-reject';
export const BONUS_BUTTON_TAKE_CASHBACK = 'bonus-button-take-cashback';
export const BONUS_LINK_GAMES = 'bonus-link-games';
export const BONUS_LINK_PLAY_GAME = 'bonus-link-play-game';
export const BONUS_LINK_AVAILABLE_BONUSES = 'bonus-link-available-bonuses';
export const BONUS_BUTTON_CLOSE = 'bonus-button-close';

export const BONUS_WAGERING_FILTER_WIDGET = 'bonus-wagering-filter-widget';
export const BONUS_WAGERING_FILTER_WIDGET_TITLE =
  'bonus-wagering-filter-widget-title';
export const BONUS_WAGERING_FILTER_WIDGET_TOOLTIP =
  'bonus-wagering-filter-widget-tooltip';
export const BONUS_WAGERING_FILTER_WIDGET_TOOLTIP_CONTENT =
  'bonus-wagering-filter-widget-tooltip-content';
export const BONUS_WAGERING_FILTER_WIDGET_TOOLTIP_TITLE =
  'bonus-wagering-filter-widget-tooltip-title';
export const BONUS_WAGERING_FILTER_WIDGET_BUTTON =
  'bonus-wagering-filter-widget-button';

export const BONUS_CANCEL_MODAL_TITLE = 'bonus-cancel-modal-title';
export const BONUS_CANCEL_BUTTON_APPLY = 'bonus-cancel-button-apply';
export const BONUS_CANCEL_BUTTON_CANCEL = 'bonus-cancel-button-cancel';

export const BONUS_CONFIRM_MODAL_TITLE = 'bonus-confirm-modal-title';
export const BONUS_CONFIRM_MODAL_SUBTITLE = 'bonus-confirm-modal-subtitle';
export const BONUS_CONFIRM_MODAL_CONFIRM_BUTTON =
  'bonus-confirm-modal-confirm-button';
export const BONUS_CONFIRM_MODAL_CANCEL_BUTTON =
  'bonus-confirm-modal-cancel-button';

export const PROVIDERS_SORTING_MODAL_TITLE = 'providers-sorting-modal-title';
export const PROVIDERS_SORTING_MODAL_CLOSE_BUTTON =
  'providers-sorting-modal-close-button';
export const PROVIDERS_SORTING_MODAL_OPTIONS_LIST =
  'providers-sorting-modal-options-list';
export const PROVIDERS_SORTING_MODAL_OPTION = 'providers-sorting-modal-option';
export const PROVIDERS_SORTING_MODAL_OPTIONS_APPLY_BUTTON =
  'providers-sorting-modal-apply-button';
export const PROVIDERS_SORTING_MODAL_OPTIONS_CANCEL_BUTTON =
  'providers-sorting-modal-cancel-button';

export const BONUS_DETAILS = 'bonus-details';
export const BONUS_DETAILS_BUTTONS_AFTER_DESC =
  'bonus-details-buttons-after-description';
export const BONUS_DETAILS_BUTTONS_AFTER_TERMS =
  'bonus-details-buttons-after-terms';
export const BONUS_TERMS = 'bonus-terms';
export const BONUS_TERMS_TITLE = 'bonus-terms-title';

export const HALL_OF_FAME_NO_CONTENT = 'hall-of-fame-no-content';
export const HALL_OF_FAME_NO_CONTENT_IMAGE = 'hall-of-fame-no-content-image';
export const HALL_OF_FAME_NO_CONTENT_TITLE = 'hall-of-fame-no-content-content';
export const HALL_OF_FAME_NO_CONTENT_DESCRIPTION =
  'hall-of-fame-no-content-description';

export const HALL_OF_FAME_TABS = 'hall-of-fame-tabs';
export const HALL_OF_FAME_TAB_CURRENT = 'hall-of-fame-tab-current';
export const HALL_OF_FAME_TAB_HISTORY = 'hall-of-fame-tab-history';

export const HALL_OF_FAME_TOP_WINS_LIST = 'hall-of-fame-top-wins-list';
export const HALL_OF_FAME_TOP_WINS_ITEM = 'hall-of-fame-top-wins-item';
export const HALL_OF_FAME_TOP_WINS_LABEL = 'hall-of-fame-top-wins-label';

export const HALL_OF_FAME_WINS_LIST = 'hall-of-fame-wins-list';
export const HALL_OF_FAME_WINS_ITEM = 'hall-of-fame-wins-item';

export const HALL_OF_FAME_AMOUNT = 'hall-of-fame-amount';
export const HALL_OF_FAME_GAME_TEXT_LINK = 'hall-of-fame-game-text-link';
export const HALL_OF_FAME_GAME_IMAGE_LINK = 'hall-of-fame-game-img-link';
export const HALL_OF_FAME_PLAYER_ID = 'hall-of-fame-player-id';

export const HALL_OF_FAME_WELCOME_POPUP = 'hall-of-fame-welcome-popup';
export const HALL_OF_FAME_WELCOME_POPUP_IMAGE =
  'hall-of-fame-welcome-popup-image';
export const HALL_OF_FAME_WELCOME_POPUP_TITLE =
  'hall-of-fame-welcome-popup-title';
export const HALL_OF_FAME_WELCOME_POPUP_DESCRIPTION =
  'hall-of-fame-welcome-popup-description';
export const HALL_OF_FAME_WELCOME_POPUP_BUTTON =
  'hall-of-fame-welcome-popup-button';

export const HALL_OF_FAME_WIN_POPUP = 'hall-of-fame-win-popup';
export const HALL_OF_FAME_WIN_POPUP_IMAGE = 'hall-of-fame-win-popup-image';
export const HALL_OF_FAME_WIN_POPUP_TITLE = 'hall-of-fame-win-popup-title';
export const HALL_OF_FAME_WIN_POPUP_DESCRIPTION =
  'hall-of-fame-win-popup-description';
export const HALL_OF_FAME_WIN_POPUP_BUTTON = 'hall-of-fame-win-popup-button';

export const BIG_WIN_CONTAINER = 'big-win-container';
export const BIG_WIN_ITEM = 'big-win-item';

export const EMPTY_PAGE = 'empty-page';
export const EMPTY_PAGE_TITLE = 'empty-page-title';
export const EMPTY_PAGE_DESCRIPTION = 'empty-page-description';

export const ERROR_PAGE_TITLE = 'error-page-title';
export const ERROR_PAGE_TO_LOBBY_LINK = 'error-page-to-lobby-link';

export const CURRENCY_CONFIRMATION_MOBILE_MODAL =
  'CURRENCY_CONFIRMATION_MOBILE_MODAL';
export const CURRENCY_CONFIRMATION_CONFIRM = 'CURRENCY_CONFIRMATION_CONFIRM';
export const CURRENCY_CONFIRMATION_DECLINE = 'CURRENCY_CONFIRMATION_DECLINE';
export const CURRENCY_CONFIRMATION_IMAGE = 'CURRENCY_CONFIRMATION_IMAGE';

export const RESPONSIBLE_GAMING_MODAL = 'LOSS_LIMITS_MODAL';
export const RESPONSIBLE_GAMING_MODAL_CONFIRM = 'LOSS_LIMITS_MODAL_CONFIRM';
export const RESPONSIBLE_GAMING_MODAL_DECLINE = 'LOSS_LIMITS_MODAL_DECLINE';

export const RECENT_GAMES_MIGRATION_MODAL = 'RECENT_GAMES_MIGRATION_MODAL';
export const RECENT_GAMES_MIGRATION_CHECKBOX =
  'RECENT_GAMES_MIGRATION_CHECKBOX';
export const RECENT_GAMES_MIGRATION_BUTTON = 'RECENT_GAMES_MIGRATION_BUTTON';

export const GAME_RECOMMENDATIONS_MODAL_TITLE =
  'GAME_RECOMMENDATIONS_MODAL_TITLE';
export const GAME_RECOMMENDATIONS_MODAL_GRID =
  'GAME_RECOMMENDATIONS_MODAL_GRID';
export const GAME_RECOMMENDATIONS_MODAL_CONTROL =
  'GAME_RECOMMENDATIONS_MODAL_CONTROL';

export const GAME_OF_THE_DAYS_CARD = 'game-of-the-day-card';

export const PLAYER_LOCK_MODAL = 'PLAYER_LOCK_MODAL';
export const PLAYER_LOCK_MODAL_CLOSE_BUTTON = 'PLAYER_LOCK_MODAL_CLOSE_BUTTON';
export const PLAYER_LOCK_MODAL_ACCEPT_BUTTON =
  'PLAYER_LOCK_MODAL_ACCEPT_BUTTON';
